/* eslint-disable max-len */
import React from 'react';

const upIcon = props => (
  <svg fill="currentColor" width="23px" height="11px" viewBox="17 0 39 35" {...props}>
    <g>
      <path d="m31.4 15.7q0 0.6-0.5 1t-1 0.4h-20q-0.6 0-1-0.4t-0.4-1 0.4-1l10-10q0.4-0.4 1-0.4t1 0.4l10 10q0.5 0.4 0.5 1z" />
    </g>
  </svg>
);

export default upIcon;
